import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid } from "@material-ui/data-grid";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import placeholderImage from "../../../images/placeholder.png";
//Global state Access
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import postImage from "../../../images/t-10.jpg";
import dayjs from "dayjs";
import moment from "moment";
import {
  HiUser,
  HiDotsHorizontal,
  HiCalendar,
  HiClock,
  HiInformationCircle,
  HiNewspaper,
  HiX,
  HiDownload,
  HiExternalLink,
  HiFilter,
  HiRefresh,
  HiSearch,
} from "react-icons/hi";
import { DatePicker, Button, Input } from "antd";

import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ProfileComponent from "../../ChurchMemberPages/Dashboard/ProfileComponent";
import ContextMenuSection from "../../ChurchMemberPages/Dashboard/ContextMenuSection";
import ChatBuddySection from "../Dashboard/ChatBuddySection";
import BuddyRequestsSection from "../Dashboard/BuddyRequestsSection";
import PdfPreview from "./PdfPreview";

const NewsListChild = () => {
  let navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [addShowModal, setAddShowModal] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const [currentRecord, setCurrentRecord] = useState({});
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [searchText, setSearchText] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);
  const [isDateFiltered, setIsDateFiltered] = useState(false);

  const [{ errorLogApi, user }] = useAtom(gbState);
  const toggleModal = () => {
    setShowModal(!showModal);
  };
  const toggleAddModal = () => {
    setAddShowModal(!addShowModal);
  };
  const currentDate = new Date();

  const getDataFromServer = () => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/news/frontend/${user.church_id}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data.users));
        const oldData = response.data.news;
        console.log(oldData);
        const updatedData = oldData
          // .filter(item => new Date(item.createdAt) >= currentDate)
          .map((data) => {
            return {
              ...data,
              id: data._id,
              title: data.title,
              description: data.description,
            };
          });

        setData(updatedData);
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  };

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/news/frontend/${user.church_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then(function (response) {
          //console.log(JSON.stringify(response.data.users));
          const oldData = response.data.news;
          console.log(oldData);
          const updatedData = oldData
            // .filter((item) => new Date(item.createdAt) >= currentDate)
            .map((data) => {
              return {
                ...data,
                id: data._id,
                title: data.title,
                description: data.description,
              };
            });

          setData(updatedData);
          setFilteredData([]);
          setIsFiltered(false);
          setIsDateFiltered(false);
        })
        .catch(function (err) {
          console.log("error api call ", err);
        });
    };
    getDataFromServer();
  }, [addShowModal]);

  const handleDownloadClick = (pdfFile) => {
    // Replace 'your-pdf-file.pdf' with the path to your PDF file
    const pdfFilePath = `${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/news/${pdfFile}`;

    // Use the 'a' element to trigger the download
    const link = document.createElement("a");
    link.href = pdfFilePath;
    link.download = { pdfFile }; // You can customize the downloaded file name
    link.target = "_blank"; // Open the link in a new tab

    // Dispatch a click event on the 'a' element to start the download
    link.dispatchEvent(new MouseEvent("click"));
  };

  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setImageModal(true);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    setImageModal(false);
  };

  const handleDownloadPDF = (url, filename) => {
    window.open(url, "_blank");
  };

  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
  };

  const handleSearchTextChange = (e) => {
    const value = e.target.value;
    setSearchText(value);

    // Instantly apply text filter
    applyTextFilter(value);
  };

  const applyTextFilter = (text) => {
    // If there's no text, but date filter is active, keep date filter only
    if (text.trim() === "") {
      if (isDateFiltered) {
        applyDateFilter();
      } else {
        setFilteredData([]);
        setIsFiltered(false);
      }
      return;
    }

    // Get base data (either date filtered or original)
    const baseData = isDateFiltered ? filteredData : data;
    const searchLower = text.toLowerCase();

    // Filter based on text
    const filtered = baseData.filter(
      (news) =>
        news.title.toLowerCase().includes(searchLower) ||
        news.description.toLowerCase().includes(searchLower)
    );

    setFilteredData(filtered);
    setIsFiltered(true);
  };

  const applyDateFilter = () => {
    if (dateRange[0] && dateRange[1]) {
      const startDate = dateRange[0].startOf("day");
      const endDate = dateRange[1].endOf("day");

      // If search text exists, filter from original data then apply text filter after
      let filtered = data.filter((news) => {
        const newsDate = dayjs(news.createdAt);
        return newsDate.isAfter(startDate) && newsDate.isBefore(endDate);
      });

      setIsDateFiltered(true);

      // If text search is active, further filter the results
      if (searchText.trim() !== "") {
        const searchLower = searchText.toLowerCase();
        filtered = filtered.filter(
          (news) =>
            news.title.toLowerCase().includes(searchLower) ||
            news.description.toLowerCase().includes(searchLower)
        );
      }

      setFilteredData(filtered);
      setIsFiltered(true);
    }
  };

  const resetFilter = () => {
    setDateRange([null, null]);
    setSearchText("");
    setFilteredData([]);
    setIsFiltered(false);
    setIsDateFiltered(false);
  };

  const columns = [
    {
      field: "Action",
      headerName: "Action",
      width: 120,
      sortable: false,
      hideable: false,
      renderCell: (params) => {
        return (
          <div className="flex flex-row">
            <Tooltip title="View details">
              <div
                onClick={() => {
                  toggleModal();
                  setCurrentRecord(params.row);
                }}
              >
                <i
                  className="cursor-pointer mdi mdi-eye-circle-outline"
                  style={{ fontSize: "15px", color: "black" }}
                ></i>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "image",
      headerName: "Image",
      sortable: false,
      hideable: false,
      disableColumnMenu: true,
      width: 100,
      align: "center",
      renderCell: (params) => {
        if (params.row.image) {
          if (params.row.image.includes(".pdf")) {
            return (
              <div>
                <button
                  onClick={() => handleDownloadClick(params.row.image)}
                  style={{ color: "blue" }}
                >
                  View Pdf
                </button>
              </div>
            );
          } else {
            return (
              <img
                crossOrigin="anonymous"
                src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/news/${params.row.image}`}
                alt="Image"
                className="w-[55px] p-1 mr-1"
              />
            );
          }
        } else {
          return (
            <img
              src={placeholderImage}
              alt="Image"
              className="w-[55px] p-1 mr-1"
            />
          );
        }
      },
    },
    {
      field: "title",
      headerName: "Title",
      width: 300,
    },
    {
      field: "description",
      headerName: "Description",
      width: 600,
    },
  ];

  return (
    <div className="flex flex-grow min-h-screen bg-gray-50">
      <div className="w-full px-4 py-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="flex flex-col">
          {/* Header Section */}
          <div className="mb-8">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-3xl font-bold text-gray-900">
                  Church Newsletter
                </h1>
                <p className="mt-2 text-gray-600">
                  Stay informed with our latest news and updates
                </p>
              </div>
              <div className="hidden sm:block">
                <div className="p-3 bg-white shadow-sm rounded-xl">
                  <div className="flex items-center space-x-2">
                    <HiNewspaper className="w-5 h-5 text-indigo-500" />
                    <span className="text-sm font-medium text-gray-600">
                      {dayjs().format("MMMM DD, YYYY")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-32 h-1 mt-4 bg-indigo-500 rounded-full"></div>

            {/* Combined Filters Row */}
            <div className="mt-6">
              <div className="flex flex-col space-y-4 lg:flex-row lg:items-center lg:space-x-4 lg:space-y-0">
                {/* Text Search Filter */}
                <div className="flex-grow">
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <HiSearch className="w-5 h-5 text-gray-400" />
                    </div>
                    <Input
                      placeholder="Search by title or description..."
                      value={searchText}
                      onChange={handleSearchTextChange}
                      className="w-full h-10 pl-10 pr-4 border border-gray-200 rounded-lg shadow-sm"
                    />
                  </div>
                </div>

                {/* Date Range Filter with Button */}
                <div className="flex flex-col space-y-2 sm:flex-row sm:items-center sm:space-y-0 sm:space-x-2">
                  <div className="flex items-center h-10 p-2 bg-white border border-gray-200 rounded-lg shadow-sm">
                    <HiFilter className="w-5 h-5 mr-2 text-indigo-500" />
                    <DatePicker.RangePicker
                      value={dateRange}
                      onChange={handleDateRangeChange}
                      format="MM-DD-YYYY"
                      className="h-full border-0 shadow-none"
                      placeholder={["Start date", "End date"]}
                      size="middle"
                    />
                  </div>
                  <div className="flex space-x-2">
                    <Button
                      type="primary"
                      onClick={applyDateFilter}
                      disabled={!dateRange[0] || !dateRange[1]}
                      className="flex items-center justify-center h-10 px-4 text-white bg-indigo-500 border-0 rounded-md shadow-sm hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      Apply Date Filter
                    </Button>
                    {isFiltered && (
                      <Button
                        onClick={resetFilter}
                        className="flex items-center justify-center h-10 px-4 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      >
                        <HiRefresh className="w-4 h-4 mr-1" />
                        Reset
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Filter Status Message */}
            {isFiltered && (
              <div className="p-2 mt-4 rounded-md bg-indigo-50">
                <p className="text-sm text-indigo-700">
                  {filteredData.length === 0
                    ? "No newsletters found matching your filters"
                    : `Showing ${filteredData.length} filtered newsletters`}
                  {isDateFiltered &&
                    dateRange[0] &&
                    dateRange[1] &&
                    ` from ${dateRange[0].format(
                      "MMMM DD, YYYY"
                    )} to ${dateRange[1].format("MMMM DD, YYYY")}`}
                  {searchText && ` containing "${searchText}"`}
                </p>
              </div>
            )}
          </div>

          {/* Image Modal */}
          {imageModal && (
            <div
              className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
              onClick={closeImageModal}
            >
              <div className="relative w-full max-w-4xl mx-4">
                <button
                  className="absolute text-white transition-colors duration-200 top-4 right-4 hover:text-gray-300"
                  onClick={closeImageModal}
                >
                  <HiX className="w-8 h-8" />
                </button>
                <img
                  src={selectedImage}
                  alt="Newsletter"
                  className="w-full h-auto rounded-lg"
                  crossOrigin="anonymous"
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
            </div>
          )}

          <div className="space-y-6">
            {(isFiltered ? filteredData : data) &&
            (isFiltered ? filteredData : data).length > 0 ? (
              (isFiltered ? filteredData : data).map((item, index) => (
                <div
                  key={index}
                  className="overflow-hidden transition-shadow duration-300 bg-white shadow-sm rounded-xl hover:shadow-md"
                >
                  <div className="p-6">
                    <div className="flex items-start justify-between">
                      <div className="flex items-center space-x-4">
                        {item?.createdBy?.image &&
                        item?.createdBy?.image !== "undefined" ? (
                          <img
                            crossOrigin="anonymous"
                            src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/employee/${item?.createdBy?.image}`}
                            className="object-cover border-2 border-gray-200 rounded-full w-14 h-14"
                            alt={`${item?.createdBy?.first_name}'s profile`}
                          />
                        ) : (
                          <div className="flex items-center justify-center bg-gray-200 rounded-full w-14 h-14">
                            <HiUser className="w-8 h-8 text-gray-400" />
                          </div>
                        )}
                        <div>
                          <h3 className="font-semibold text-gray-900">
                            {item?.createdBy?.first_name}{" "}
                            {item?.createdBy?.last_name}
                            <span className="font-normal text-gray-500">
                              {" "}
                              - Shared Newsletter
                            </span>
                          </h3>
                          <p className="text-sm text-gray-500">
                            {moment(item.createdAt).fromNow()}
                          </p>
                        </div>
                      </div>
                      <button className="p-2 transition-colors duration-200 rounded-full hover:bg-gray-100">
                        <HiDotsHorizontal className="w-5 h-5 text-gray-500" />
                      </button>
                    </div>

                    <div className="mt-4">
                      <h4 className="text-lg font-semibold text-gray-900">
                        {item.title}
                      </h4>
                      <p className="mt-2 leading-relaxed text-gray-600">
                        {item.description}
                      </p>
                    </div>

                    <div className="mt-4 space-y-2">
                      <div className="flex items-center text-gray-500">
                        <HiCalendar className="w-5 h-5 mr-2" />
                        <span className="text-sm">
                          {dayjs(item.createdAt).format("MMMM DD, dddd YYYY")}
                        </span>
                      </div>
                      <div className="flex items-center text-gray-500">
                        <HiClock className="w-5 h-5 mr-2" />
                        <span className="text-sm">
                          {dayjs(item.createdAt).format("hh:mm A")}
                        </span>
                      </div>
                    </div>

                    {item?.image && (
                      <div className="mt-6">
                        {item?.image.includes(".pdf") ? (
                          <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
                            <div className="flex items-center justify-between">
                              <div className="flex items-center space-x-3">
                                <div className="p-2 bg-red-100 rounded-lg">
                                  <HiNewspaper className="w-6 h-6 text-red-600" />
                                </div>
                                <div>
                                  <p className="font-medium text-gray-900">
                                    Newsletter PDF
                                  </p>
                                  <p className="text-sm text-gray-500">
                                    Click to view or download
                                  </p>
                                </div>
                              </div>
                              <div className="flex space-x-2">
                                <button
                                  onClick={() =>
                                    window.open(
                                      `${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/news/${item?.image}`,
                                      "_blank"
                                    )
                                  }
                                  className="p-2 text-gray-600 transition-colors duration-200 rounded-lg hover:bg-gray-200"
                                  title="View PDF"
                                >
                                  <HiExternalLink className="w-5 h-5" />
                                </button>
                                <button
                                  onClick={() =>
                                    handleDownloadPDF(
                                      `${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/news/${item?.image}`,
                                      item?.image
                                    )
                                  }
                                  className="p-2 text-gray-600 transition-colors duration-200 rounded-lg hover:bg-gray-200"
                                  title="Download PDF"
                                >
                                  <HiDownload className="w-5 h-5" />
                                </button>
                              </div>
                            </div>
                            <PdfPreview
                              file_url={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/news/${item?.image}`}
                            />
                          </div>
                        ) : (
                          <img
                            src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/news/${item?.image}`}
                            className="object-cover w-full transition-opacity duration-200 rounded-lg cursor-pointer max-h-96 hover:opacity-90"
                            alt="Newsletter"
                            crossOrigin="anonymous"
                            onClick={() =>
                              openImageModal(
                                `${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/news/${item?.image}`
                              )
                            }
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="p-6 text-center bg-white shadow-sm rounded-xl">
                <HiInformationCircle className="w-12 h-12 mx-auto mb-4 text-gray-400" />
                <p className="text-lg font-semibold text-gray-900">
                  {isFiltered
                    ? "No newsletters found matching your filters"
                    : "No newsletters available"}
                </p>
                <p className="mt-1 text-gray-500">
                  {isFiltered
                    ? "Try adjusting your search criteria"
                    : "Check back later for updates"}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsListChild;
